import { window } from "global";
import { useEffect } from "react";
import { ContentSidePadding } from "components/ContentSidePadding";
import { PlusHomePage } from "components/Plus/PlusHomePage";
import { usePageTitleAndDesc } from "@ugg/shared/utils/seo-helpers";

const Plus = () => {
  const getPageTitleAndDesc = usePageTitleAndDesc();

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex justify-center mx-auto w-full max-md:w-full">
      {getPageTitleAndDesc("plus")}
      <ContentSidePadding className="mx-auto w-[1016px] max-md:w-full box-content">
        <PlusHomePage />
      </ContentSidePadding>
    </div>
  );
};

export default Plus;
